export class RecommendedProduct extends window.BAO.CustomElement() {
  // connectedCallback () {
  //   super.connectedCallback()
  // }
  setupListeners () {
    super.setupListeners()

    if (!this.els?.select?.element) return

    this.els.select.element.addEventListener('change', this.onSelectChange.bind(this))
  }

  onSelectChange () {
    this.els.id.element.value = this.els.select.element.value
    this.els.submit.element.click()
  }
}

customElements.define('recommended-product', RecommendedProduct)
